// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"abd5bc96","842":"873f8ab4"}[chunkId] + ".chunk.js";
};